export interface QuestionAndAnswer {
  question: string;
  answer: string;
}

export interface PostTranslationBg {
  title?: string;
  content?: string;
  questionsAndAnswers?: QuestionAndAnswer[];
}

export interface PostProperties {
  id?: number;
  title: string;
  content: string;
  image: string;
  buttonText: string;
  buttonUrl: string;
  category: "Lost Gem" | "Expose";
  questionsAndAnswers?: QuestionAndAnswer[];
  embedCode?: string | TrustedHTML;
  translationsBg?: PostTranslationBg;
}

export function resolvePost(
  post: PostProperties,
  lang: "en" | "bg",
): PostProperties {
  if (lang === "bg" && post.translationsBg) {
    return {
      ...post,
      title: post.translationsBg.title ?? post.title,
      content: post.translationsBg.content ?? post.content,
      questionsAndAnswers:
        post.translationsBg.questionsAndAnswers ?? post.questionsAndAnswers,
    };
  }
  return post;
}
